module.exports = __webpack_public_path__ + "img/banner_bag_big_a9ff65d.webp";